export default [{
  cs: 'bodyStyleSubtypeCodes',
  lsc: 'bodyStyleSubtypeCode'
}, {
  cs: 'dealTypes',
  lsc: 'dealType'
}, {
  cs: 'doorCodes',
  lsc: 'doorCode'
}, {
  cs: 'engineCodes',
  lsc: 'engineCode'
}, {
  cs: 'extColorsSimple',
  lsc: 'extColorSimple'
}, {
  cs: 'featureCodes',
  lsc: 'featureCode'
}, {
  cs: 'interiorColorsSimple',
  lsc: 'intColorSimple'
}, {
  cs: 'listingFeatures',
  lsc: 'listingFeature'
}, {
  cs: 'listingTypes',
  lsc: 'listingType'
}, {
  cs: 'makeCodeList',
  lsc: 'makeCode'
}, {
  cs: 'maxMileage',
  lsc: 'mileage'
}, {
  cs: 'modelCodeList',
  lsc: 'modelCode'
}, {
  cs: 'mpgRanges',
  lsc: 'mpgRange'
}, {
  cs: 'packages',
  lsc: 'packageName'
}, {
  cs: 'priceRange',
  lsc: 'price'
}, {
  cs: 'sellerTypes',
  lsc: 'sellerType'
}, {
  cs: 'seriesCodeList',
  lsc: 'seriesCode'
}, {
  cs: 'seriesTrimCodeList',
  lsc: 'seriesTrimCode'
}, {
  cs: 'transmissionCodes',
  lsc: 'transmissionCode'
}, {
  cs: 'trimCodeList',
  lsc: 'trimCode'
}, {
  cs: 'vehicleStyleCodes',
  lsc: 'vehicleStyleCode'
}, {
  cs: 'vhrTypes',
  lsc: 'vehicleHistoryType'
}, {
  cs: 'isNewSearch',
  lsc: 'newSearch'
}];